{
    "actions": {
        "page": {
            "create_envelopes": {
                "title": "Créer enveloppes",
                "select": "Créer par sélection",
                "upload": "Créer par fichier CSV"
            },
            "create_download_code": "Créer code de téléchargement",
            "deprogram": "Déprogrammer"
        },
        "row": {
            "update_download_code": "Modifier"
        }
    },
    "filter": {
        "placeholder": {
            "envelopes": {
                "access_code": "Filtrer par code d'accés",
                "client_name": "Filtrer par client",
                "download_server_ip_address_port": "Filtrer par IP serveur",
                "serial_number": "Filtrer par Série"
            },
            "download_codes": {
                "code_name": "Filtrer par nom du code",
                "created_by": "Filtrer par le créateur"
            }
        }
    },
    "form": {
        "placeholder": {
            "end_date": "Pas d'expiration",
            "start_date": "Dès réception",
            "access_code": "4 à 9 chiffres (ex: 1234)",
            "server_ip": "ex: 121.122.123.124:10000",
            "code_name": "ex: Campagne migration FRV6 Move 5000"
        }
    },
    "keys": {
        "envelopes": {
            "access_code": "Code d'accès",
            "client": "Client",
            "code_name": "Nom du code",
            "created_at": "Créée le",
            "schedule_start": "Début de programmation",
            "schedule_end": "Fin de programmation",
            "sent_at": "Envoyée le",
            "serial_number": "# Série",
            "server_ip": "IP Serveur",
            "status": "Statut"
        },
        "download_codes": {
            "created_at": "Crée le",
            "created_by": "Crée par"
        }
    },
    "modal": {
        "create_envelopes": {
            "select_csv": "Import par fichier",
            "select_form": "Formulaire (20 TPE maximum)",
            "success": "Opération réalisée avec succès !",
            "title": "Créer des enveloppes",
            "terminal_serial_numbers": "{{numberOfSelectedItems}} TPE sélectionnés",
            "steps": {
                "client_selection": "Étape {{step}} sur {{maxStep}}: Sélectionnez un client",
                "pos_terminal_selection": "Étape {{step}} sur {{maxStep}}: Sélectionnez les terminaux",
                "form_fill": "Étape {{step}} sur {{maxStep}}: Complétez le formulaire"
            }
        },
        "import": {
            "explanations": {
                "header": "Vous pouvez programmer plusieurs enveloppes de téléchargement à la fois. Le fichier à importer doit contenir les 6 colonnes suivantes :",
                "serial_number": "Numéro de série des terminaux",
                "client": "Nom du client (ClientName)",
                "start_date": "Date de début de programmation",
                "end_date": "Date de fin de programmation",
                "access_code": "Code d'accès",
                "server_ip": "IP Serveur"
            },
            "confirmation": {
                "single": "Cette opération va créer {{numberOfEnvelopes}} enveloppe. Souhaitez-vous continuer ?",
                "multiple": "Cette opération va créer {{numberOfEnvelopes}} enveloppes. Souhaitez-vous continuer ?"
            },
            "error": {
                "BAD_FORMAT": "Le fichier n'est pas au bon format.",
                "BAD_FILE_FORMAT": "Le fichier n'est pas au bon format.",
                "UNEXPECTED_ERROR": "Une erreur inconnue est survenue.",
                "INTERNAL_SERVER_ERROR": "Une erreur interne est survenue.",
                "invalid_file": "Ce fichier n'est pas compatible (.csv uniquement)",
                "get_example_file": "N'hésitez pas à télécharger notre modèle de fichier pour faciliter le remplissage.",
                "csvBadLineFormat": {
                    "single": "{{linesNumber}} ligne dans le fichier n'est pas au bon format.",
                    "multiple": "{{linesNumber}} lignes dans le fichier ne sont pas au bon format.",
                    "all": "Toutes les lignes dans le fichier ne sont pas au bon format."
                },
                "scheduledDatesInThePast": "Les enveloppes ne peuvent être programmées à des dates passées. Veuillez saisir des dates de début et de fin futures ou laisser les champs vides.",
                "alreadyExistingSerialNumberInCsv": "La ligne pour ce terminal est en doublon dans le fichier fourni. L'enveloppe a été créée et les doublons ont ensuite été ignorés.",
                "serialNumbersNotFound": {
                    "single": "Terminal non trouvé, veuillez vérifier le numéro de série saisi.",
                    "multiple": "Terminaux non trouvés, veuillez vérifier le numéro de série saisi."
                },
                "existingEnvelope": {
                    "single": "Il existe déjà une enveloppe programmée pour ce terminal. Veuillez la supprimer avant d'en programmer une nouvelle.",
                    "multiple": "Il existe déjà une enveloppe programmée pour ces terminaux. Veuillez la supprimer avant d'en programmer une nouvelle."
                },
                "notFoundOrganization": {
                    "single": "Client non trouvé, veuillez vérifier que la saisie correspond exactement au nom de l'organisation.",
                    "multiple": "Clients non trouvés, veuillez vérifier que la saisie correspond exactement au nom de l'organisation."
                },
                "unauthorizedProviderForSerialNumbers": "L'organisation ciblée pour la création d'enveloppe n'est pas disponible.",
                "manyOrganizationsWithSameName": {
                    "single": "Le nom d'une organisation correspond à plusieurs organisations différentes. La création d'enveloppe n'est possible que pour des organisations dont le nom est unique. Nous vous invitons à modifier le nom des organisations et à recommencer la création d'enveloppe.",
                    "multiple": "Le nom d'organisations correspondent à plusieurs organisations différentes. La création d'enveloppe n'est possible que pour des organisations dont le nom est unique. Nous vous invitons à modifier le nom des organisations et à recommencer la création d'enveloppe."
                },
                "posList": "{{posTerminalList}}",
                "clientList": "{{clientList}}",
                "organizationList": "{{organizationNameList}}"
            },
            "message": "Veuillez télécharger le fichier exemple.",
            "success": "Envelopes créées avec succès !"
        },
        "create_download_code": {
            "title": "Complétez le formulaire",
            "success": "Opération réalisée avec succès !"
        },
        "deprogram": {
            "title": "Déprogrammer",
            "message_single": "Cette opération va déprogrammer {{number}} enveloppe. Souhaitez-vous continuer ?",
            "message_many": "Cette opération va déprogrammer {{number}} enveloppes. Souhaitez-vous continuer ?",
            "steps": {
                "envelopes_selection": "Étape {{step}} sur {{maxStep}}: Sélectionnez les enveloppes",
                "confirm": "Étape {{step}} sur {{maxStep}}: Confirmer la déprogrammation"
            },
            "success": "Opération réalisée avec succès !",
            "error": {
                "not_deleted_single": "L'enveloppe suivante n'a pas pu être déprogrammée.",
                "not_deleted_multiple": "Les enveloppes suivantes n'ont pas pu être déprogrammées.",
                "unknown_error": "Une erreur est survenue lors de la déprogrammation"
            }
        },
        "update_download_code": {
            "success": "Code de téléchargement mis à jour avec succès !"
        },
        "errors": {
            "ALREADY_EXISTING_ACCESS_OR_CODE_NAME": "Echec de l'opération, campagne ou code accèss déjà existants.",
            "UNKNOWN_ERROR": "Une erreur inconnue est survenue."
        }
    },
    "status": {
        "SCHEDULED": "Programmée",
        "SENT": "Envoyée",
        "ERROR": "Erreur"
    }
}